import { render, staticRenderFns } from "./BeforePos.vue?vue&type=template&id=49ea1fda&scoped=true"
import script from "./BeforePos.vue?vue&type=script&lang=js"
export * from "./BeforePos.vue?vue&type=script&lang=js"
import style0 from "./BeforePos.vue?vue&type=style&index=0&id=49ea1fda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ea1fda",
  null
  
)

export default component.exports